export default function getApiMessage(locale, value, valueES) {
    return locale === "es" && valueES ? valueES : value;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/getApiMessage.ts